import React from 'react';
import { Link, withRouter } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import { connect } from 'react-redux';
import Table from 'components/Table/Table.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from 'components/inc/PageTitle.jsx';
import { getAllSprintList } from '../../actions/sprint';
import { getProjectDetails } from '../../actions/project';
import LoadingComponent from 'components/inc/LoadingComponent.jsx';
import style from 'assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx';
import styles from 'assets/jss/customStyle.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import _ from 'lodash-es';

class SprintListUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: !_.isEmpty(props.projectData)
        ? props.projectData[props.match.params.id]
        : {},
    };
  }

  componentDidMount() {
    let projectId = this.props.match.params.id;
    if (
      _.isEmpty(this.props.projectData) ||
      !this.props.projectData[projectId]
    ) {
      this.props.loadProjectInfo(projectId);
    }
    if (this.props.projectData[projectId] && _.isEmpty(this.state.project)) {
      this.setState({
        project: this.props.projectData[projectId],
      });
    }
    this.props.loadSprintLists(projectId);
  }

  render() {
    const { classes, sprintListData, isFetching } = this.props;
    const { project } = this.state;
    let sprints = [];
    if (sprintListData) {
      for (const key in sprintListData) {
        const val = sprintListData[key];
        const sprintRowData = [];
        sprintRowData.push(
          <Link to={`/projects/${val.project}/sprints/${val._id}`}>
            {val.title}
          </Link>
        );

        sprintRowData.push(val.sprintType || 'N/A');
        if (val.sprintStatus.status === 'Draft') {
          sprintRowData.push(
            <div className='sprintStatus'>
              <Link to={`/projects/${val.project}/sprints/${val._id}`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='danger'
                  round
                >
                  {val.sprintStatus.status}
                </Button>
              </Link>
            </div>
          );
        } else if (val.sprintStatus.status === 'In Progress') {
          sprintRowData.push(
            <div className='sprintStatus'>
              <Link
                to={{
                  pathname: `/projects/${val.project}/sprints/${val._id}/info`,
                  state: { projectId: project._id, sprintId: val._id },
                }}
              >
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='warning'
                  round
                >
                  {val.sprintStatus.status}
                </Button>
              </Link>
            </div>
          );
        } else if (val.sprintStatus.status === 'Complete') {
          sprintRowData.push(
            <div className='sprintStatus'>
              <Link to={`/projects/${val.project}/sprints/${val._id}/info`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='success'
                  round
                >
                  {val.sprintStatus.status}
                </Button>
              </Link>
            </div>
          );
        } else {
          sprintRowData.push(
            <div className='sprintStatus'>
              <Link
                to={{
                  pathname: `/projects/${val.project}/sprints/${val._id}/info`,
                  state: { projectId: val.project, sprintId: val._id },
                }}
              >
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='default'
                  round
                >
                  {val.sprintStatus.status}
                </Button>
              </Link>
            </div>
          );
        }
        sprints.push(sprintRowData);
      }
    }

    return (
      <div>
        <LoadingComponent
          isLoading={isFetching || !(sprintListData && project)}
        >
          <GridContainer alignItems='center' justify='space-between'>
            <GridItem xs={12} md={6}>
              <PageTitle title={project.title} />
              <h5>Project's sprints</h5>
            </GridItem>
            <GridItem xs={12} md={6}>
              <div style={{ textAlign: 'right', paddingRight: '1rem' }}>
                <Link
                  className='title-nav-link'
                  to={`/projects/${project._id}/create-sprint`}
                >
                  <Button
                    round
                    style={{ marginRight: '10px' }}
                    size='sm'
                    color='primary'
                  >
                    Create Sprint
                  </Button>
                </Link>
              </div>
            </GridItem>
          </GridContainer>
          <Table
            striped={true}
            tableHead={['Sprint', 'Type', 'Status']}
            tableData={sprints}
            customCellClasses={[
              classes.textLeft,
              classes.textLeft,
              `text-align-right `,
            ]}
            customClassesForCells={[0, 1, 2]}
            customHeadCellClasses={[
              classes.textLeft,
              classes.textLeft,
              `text-align-right padding-right-4`,
            ]}
            customHeadClassesForCells={[0, 1, 2]}
          />
        </LoadingComponent>
        <Link to='/'>
          <Button round style={{ marginTop: '2rem' }} size='sm' color='success'>
            Back
          </Button>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFetching: state.sprint.isFetching,
  sprintListData: state.sprint.data,
  projectData: state.project.data,
});

const mapDispatchToProps = (dispatch) => ({
  loadSprintLists: (projectId) => dispatch(getAllSprintList(projectId)),
  loadProjectInfo: (projectId) => dispatch(getProjectDetails(projectId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(withRouter(SprintListUser)));
